import React from "react"
import BuiltInLogicImage from "../../../../../components/staticQuery/platform/automation/BuiltInLogicImage"
import P from "../../../../../components/typography/P"
import FlowGraphic from "../../../../../images/platform/automation/flow.svg"

const DescriptionText = () => (
  <>
    <P>
      Creating logic-based Branching is extremely useful when you need to take a
      Contact down different paths based on an answer to a question or data
      capture from a Form, Poll, Question, Feedback, etc.
    </P>
    <P>
      Enjoy powerful options like multi-criteria Branching, A/B Testing, Branch
      Priority, Primary/Alternate Branches and intelligent Wait options to
      deliver the perfect communication in every situation.
    </P>
  </>
)

const builtInLogicData = {
  titleIcon: FlowGraphic,
  title: "Built in Logic",
  description: <DescriptionText />,
  graphic: <BuiltInLogicImage />,
  imageLeft: true,
  textLong: false,
  tint: "#F2F5F8",
  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 6vw))",
  benefits: [
    {
      benefitName: "Conditional Logic",
    },
    {
      benefitName: "Set Branch Priority or Execute on All Matches",
    },
    {
      benefitName: "Separate Primary and Alternate Branch Logic",
    },
    {
      benefitName: "A/B Testing",
    },
  ],
}

export default builtInLogicData
